import { normalizeEmailDomain, normalizeEmailDomains } from './companyEmailDomainApi.utils';

export class CompanyEmailDomainApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getEmailDomains(companyId) {
    const response = await this.#http.get(`/api/companies/${companyId}/email-domains`);

    return { ...response, data: normalizeEmailDomains(response.data) };
  }

  async createEmailDomain(companyId, { domainName, kind }) {
    const response = await this.#http.post(`/api/companies/${companyId}/email-domains`, {
      domainName,
      kind,
    });

    return { ...response, data: normalizeEmailDomain(response.data) };
  }

  async verifyEmailDomain(companyId, domainId) {
    const response = await this.#http.post(
      `/api/companies/${companyId}/email-domains/${domainId}/verify`,
    );

    return { ...response, data: normalizeEmailDomain(response.data) };
  }

  // A rejected test send answers 200 with `isSuccess: false` and a readable `message` — a failed test is
  // the ANSWER the caller asked for, not a transport error, so it must not be handled as a rejection.
  async sendTestEmail(companyId, domainId, { toEmail }) {
    return this.#http.post(`/api/companies/${companyId}/email-domains/${domainId}/test-email`, {
      toEmail,
    });
  }

  async setDefaultEmailDomain(companyId, domainId) {
    return this.#http.put(`/api/companies/${companyId}/email-domains/${domainId}/default`);
  }

  async updateEmailSendingIdentity(companyId, domainId, { fromName, fromEmail }) {
    const response = await this.#http.put(
      `/api/companies/${companyId}/email-domains/${domainId}/sending-identity`,
      { fromName, fromEmail },
    );

    return { ...response, data: normalizeEmailDomain(response.data) };
  }

  // A rejected send comes back 200 with `isSuccess: false` and a readable `message` — same contract
  // as `sendTestEmail` — so only a transport failure reaches the caller's `.catch`.
  async emailDnsRecords(companyId, domainId, { toEmail }) {
    return this.#http.post(`/api/companies/${companyId}/email-domains/${domainId}/email-records`, {
      toEmail,
    });
  }

  async deleteEmailDomain(companyId, domainId) {
    return this.#http.delete(`/api/companies/${companyId}/email-domains/${domainId}`);
  }
}
